const notifyMeButton = document.querySelector('[data-open-notify-me-modal]');
const notifyMeModal = document.querySelector('#out-of-stock-drawer');

if (notifyMeButton && notifyMeModal) {
  notifyMeButton.addEventListener('click', openNotifyMeModal);
}

function openNotifyMeModal(e) {
  e.preventDefault();
  const currButton = e.target;
  const notifyMeListId = currButton.dataset.klaviyoListId;
  const notifyMeCompanyId = currButton.dataset.klaviyoCompanyId;
  notifyMeModal.setAttribute('data-klaviyo-list-id', notifyMeListId);
  notifyMeModal.setAttribute('data-klaviyo-company-id', notifyMeCompanyId);
  notifyMeModal.setAttribute('data-modal-type', 'notify-me');
  notifyMeModal.querySelector('.backinstock-btn').classList.add('d-none');
  notifyMeModal.querySelector('.notify-me-btn').classList.remove('d-none');

  notifyMeModal.classList.add('is-open');

  if (notifyMeModal.getAttribute('data-modal-type') === 'notify-me') {
    notifyMeModal.querySelector('form').addEventListener('submit', notifyMe);
  }
}

async function notifyMe(e) {
  e.preventDefault();
  const email = notifyMeModal.querySelector('#bis-email').value;
  const klaviyoListId = notifyMeModal.getAttribute('data-klaviyo-list-id');
  const klaviyoCompanyId = notifyMeModal.getAttribute(
    'data-klaviyo-company-id'
  );

  if (notifyMeModal.querySelector('#bis-newsletter').checked != true) {
    return;
  }

  if (email && klaviyoListId) {
    const storeMap = {
      BE: '4ce904e4-ef54-460c-96ab-d27f63c19e61',
      AU: '4ce904e4-ef54-460c-96ab-d27f63c19e61',
      CA: '4ce904e4-ef54-460c-96ab-d27f63c19e61',
      NZ: '4ce904e4-ef54-460c-96ab-d27f63c19e61',
      KR: '4ce904e4-ef54-460c-96ab-d27f63c19e61',
      AD: '4ce904e4-ef54-460c-96ab-d27f63c19e61',
      DK: '94253566-5c4f-4050-88b8-5b5d045dded2',
      DE: '3933782f-b437-4319-9609-b9b3ad8e9c77',
      FR: 'c785a7b6-a885-4591-a80b-0c05148c54bf',
      NL: '437a9635-46eb-48a1-a0a3-78870a35c719',
      GB: '4ce904e4-ef54-460c-96ab-d27f63c19e61',
      US: '4ce904e4-ef54-460c-96ab-d27f63c19e61',
      NO: '4ce904e4-ef54-460c-96ab-d27f63c19e61',
      SE: '4ce904e4-ef54-460c-96ab-d27f63c19e61',
    };

    const productJSON = JSON.parse(
      document.querySelector('[data-product-json]').innerHTML
    );

    await fetch(
      'https://int-shopify-service-production.up.railway.app/comingSoon/save',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers':
            'Origin, X-Requested-With, Content-Type, Accept',
          'Access-Control-Allow-Methods': 'GET, PUT, POST, OPTIONS',
          'x-store-id': storeMap[window.theme.currentShop.countryCode],
          'x-tenant-id': 'e3ae5350-7f0a-4ca6-8aa2-ba1e14722531',
        },
        body: JSON.stringify({
          email,
          sendEvent: true,
          productId: 'gid://shopify/Product/' + productJSON.id,
          product: {
            id: 'gid://shopify/Product/' + productJSON.id,
            title: productJSON.title,
            image: 'https:' + productJSON.featured_image,
            collections: productJSON.tags,
            price: productJSON.price / 100,
            url: window.location.href,
            sku: productJSON.variants[0].sku,
            platform: 'shopify',
            email: email,
          },
          listId: klaviyoListId,
          companyId: klaviyoCompanyId,
        }),
      }
    );
  }
}
